import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {
  BaseApiTemplateService,
  Core2Config,
  BasicApiResponseModel,
  PagingResponseModel,
  Pagination,
  ApiVisa
} from '../../shared';
import { Observable } from "rxjs";


@Injectable({
  providedIn: 'root'
})
export class IntercompanyListingService extends BaseApiTemplateService<any> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  'intercompany';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'intercompany';
    this.httpClient = http;
  }

    // retrieve intercompany sales invoices
    public getIntercompanyFinalGendocs(pagination: Pagination, docType: String, visa: ApiVisa): Observable<PagingResponseModel<any>> {
        if (this.endpoint_path && visa.api_domain_url) {
            this.apiUrl = visa.api_domain_url + this.endpoint_path;
        }
        
        let url = this.apiUrl + '/' + docType;
        const UrlByCriteria = url + '/final/query/snapshot/backoffice-ep?' + pagination.getQueryKeyValues();
        return this.httpClient.get<PagingResponseModel<any>>(
            UrlByCriteria,
            this.getHttpHeader(visa)
        );
  }
}
